import { useState } from 'react';
import { Button, Col, Popconfirm, Row, Spin, Typography } from 'antd';
import SLPLine from './SLPLine';

const { Text } = Typography;

function SLPBlock(props) {

    const [ spinning, setSpinning ] = useState(false);

    //console.log(props.participants);

    let popconfirmDisabled = true;
    for (let i = 0; i < props.participants.list.length; i++) {
        if (props.participants.list[i]) {
            if (props.participants.list[i].position) {
                popconfirmDisabled = false;
            }    
        }
        else {
            //console.log(props.participants.list);
        }
    }

    const confirmHandler = async () => {
        setSpinning(true);
        await props.autoOrder(props.participants.sg);
        //console.log(props.participants);
        setSpinning(false);
    }

    return (
        <Spin spinning={spinning}>
            <Row gutter={[10,10]} style={{marginTop: "20px"}}>
                <Col span={24} style={{textAlign: "center"}}>
                    <Popconfirm
                        disabled={popconfirmDisabled}
                        title="Startnummern bereits vergeben! Nochmal vergeben?"
                        okText="Ja"
                        cancelText="Abbrechen"
                        onConfirm={confirmHandler}
                    >
                        <Button
                            type="primary"
                            onClick={popconfirmDisabled ? confirmHandler : null}
                        >
                            Startnummern automatisch vergeben
                        </Button>
                    </Popconfirm>
                </Col>
                <Col span={3}>
                    <Text strong>
                        Start-Nr.
                    </Text>
                </Col>
                <Col span={12}>
                    <Text strong>
                        Name
                    </Text>
                </Col>
                <Col span={5}>
                    <Text strong>
                        Verein
                    </Text>
                </Col>
                <Col span={4}>
                    <Text strong>
                        Aktion
                    </Text>
                </Col>
            </Row>
            {
                props.participants.list.map((participant, index) => {
                    if (!participant) {
                        return null;
                    }
                    let type = "";
                    if (participant.position === 1) type += "first";
                    if (index === props.participants.list.length-1) type += "last";
                    return (
                        <SLPLine 
                            key={index}
                            participant={participant}
                            type={type}
                            onChangeOrder={async (id, association, order) => {
                                setSpinning(true);
                                await props.onChangeOrder(props.participants.sg, id, association, order);
                                setSpinning(false);
                            }}
                        />
                    );
                })
            }
        </Spin>
    );
}

export default SLPBlock;